import React, { useEffect, useState } from 'react';
import { Tooltip } from "../Global/Tooltip";
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useProductStore } from 'src/hooks/product';
import Constants from 'src/helper/Constants';
import useReduxState from 'src/hooks/useReduxState';

const CustomerPartNumberOptions = (props) => {
    const { single_product, from = "", updationCompletedCallback, defaultValue, unique_id } = props;
    const [selectedCpn, setSelectedCpn] = useState('');
    let c = System.getParams();
    const [{ }, { }, { SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT, set_cart_loader_data_object }] = useCartStore();
    const [{ }, { get_product_assets }, { }, { }] = useProductStore();
    const [, setPriceSingleLoader] = useReduxState({}, 'priceSingleLoader')
    const [, setQtyLoader] = useReduxState(false, 'setQtyLoader');
    const { systemModules: { Quote, CART, BOM } } = Constants;

    useEffect(() => {
        if (c.search || c.searchTerm) {
            const searchedCPN = c.search || c.searchTerm;
            let cpnAvailable = System.isCPNAvailableInList(single_product, searchedCPN)
            if (cpnAvailable) {
                onSelectCPN(searchedCPN)
            }
        }
    }, [])

    useEffect(() => {
        if (defaultValue) {
            onSelectCPN(defaultValue)
        } //  else if (single_product?.CustomerPartNumbers.length === 1) {
        //     onSelectCPN(single_product?.CustomerPartNumbers[0].CPN)
        // }
    }, [defaultValue])

    const onSelectCPN = async (cpnVal, selectedFromDropdown = false) => {
        setSelectedCpn(cpnVal)
        if (single_product) {
            const product = { ...single_product, CPN: cpnVal, uniqueId: unique_id ? unique_id : single_product?.ItemNumber }

            let isSetPriceState = false;
            if (from === Quote) {
                setQtyLoader(true)
            }
            else {
                setPriceSingleLoader({ [single_product.ItemNumber]: { status: true } })
                set_cart_loader_data_object({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType })
                SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({ CPN: cpnVal, ItemNumber: single_product?.ItemNumber })
                isSetPriceState = true;
            }

            if (selectedFromDropdown) {
                const price = await get_product_assets({ product }, { isInventoryCall: false, isSetPriceState: isSetPriceState })
                if (from === Quote) {
                    updationCompletedCallback({ cpn: cpnVal, price: price })
                }

                if (selectedFromDropdown && (from === CART || from === BOM)) {
                    updationCompletedCallback(cpnVal)
                }
            }

            setPriceSingleLoader({ [single_product.ItemNumber]: { status: false } })
            setQtyLoader(false)

        }
    }

    return (
        <>
            {single_product?.CustomerPartNumbers?.length > 0 &&
                <div className="form-group">

                    <>
                        <label htmlFor="sel1" className="text-nowrap"><b>Customer Part Number</b>
                            {from !== Quote &&
                                <Tooltip
                                    opener={() => (<i className="fa fa-info-circle ms-1" />)}
                                    content={() => (
                                        <>
                                            {"Click the drop down to select another Customer Part Number"}
                                        </>
                                    )}
                                />
                            }
                        </label>


                        {/* // single_product?.CustomerPartNumbers?.length > 1 ? */}

                        <div className="selectbox">
                            <select
                                className="form-control form-control-xs"
                                onChange={async (e) => { onSelectCPN(e.target.value, true) }}
                                value={selectedCpn}
                                id="Customer" aria-labelledby="Choose CPN">
                                <option value="" selected>Select CPN</option>
                                {single_product?.CustomerPartNumbers.map((v, i) => (
                                    <React.Fragment key={i}>
                                        <option value={v.CPN}>{v.CPN}</option>
                                    </React.Fragment>
                                ))}
                            </select>
                        </div>
                        {/* // :
                            // <div>
                            //     {selectedCpn}
                            // </div> */}
                    </>

                </div>
            }
        </>
    );
};

export default CustomerPartNumberOptions;